module.exports = __webpack_public_path__ + "assets/img/free_29.efc1a82e.png";